var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useRef } from "react";
import styled from "styled-components";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import BackIcon from "@mui/icons-material/ArrowBack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import { useQuery } from "../../hooks";
import * as matches from "../../api/matches";
import { Alerts } from "../../components/molecules/Alerts/Alerts";
import { PageWrapperNew } from "../../components/atoms/PageWrapper";
import { useErrorHandler } from "../../hooks/useErrorHandler";
import { DataContainerNew } from "../../components/atoms/DataContainer";
const SectionPaper = styled(Paper) `
  padding: 32px;
  margin-bottom: 24px;
  background-color: #ffffff;
  border-radius: 12px;
`;
const SectionTitle = styled(Typography) `
  font-weight: 600 !important;
  margin-bottom: 24px !important;
  color: #1976d2 !important;
`;
const requiredFieldError = "Это поле необходимо заполнить";
const validationSchema = Yup.object().shape({
    isAdditional: Yup.boolean().required(requiredFieldError),
});
export const CreateMatch = () => {
    const createMatchRef = useRef();
    const nav = useNavigate();
    // const eventId = useAppSelector(selectEventId)
    const { param: eventId } = useQuery("eventId");
    const { errorHandler } = useErrorHandler();
    const initialValues = {
        isAdditional: false,
    };
    const onSubmit = (data, { setSubmitting, setFieldError }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        console.log("CreateMatch submit", data);
        if (!eventId) {
            setSubmitting(false);
            return;
        }
        try {
            const createMatchData = {
                eventId,
                isAdditional: data.isAdditional,
            };
            console.log("CreateMatch data:", createMatchData);
            const result = yield matches.createMatch(createMatchData);
            // console.log('CreateMatch createMatch', result)
            nav(`/match-config?matchId=${result.id}`);
        }
        catch (e) {
            console.error("Matches createMatch error", e);
            setFieldError("isAdditional", (_c = (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.password) === null || _c === void 0 ? void 0 : _c[0]);
            errorHandler(e);
            setSubmitting(false);
        }
    });
    return (_jsx(DataContainerNew, { children: _jsxs(PageWrapperNew, { children: [_jsx(Alerts, {}), _jsx(Button, Object.assign({ sx: { width: "fit-content", marginBottom: 3 }, startIcon: _jsx(BackIcon, {}), onClick: () => nav(`/matches?eventId=${eventId}`) }, { children: "\u041D\u0430\u0437\u0430\u0434" })), _jsx(Typography, Object.assign({ variant: "h2", sx: {
                        marginBottom: 5,
                        fontWeight: 700,
                        color: '#ffffff'
                    } }, { children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u044B" })), _jsx(Formik, Object.assign({ innerRef: createMatchRef, initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit }, { children: ({ setFieldValue, isSubmitting }) => (_jsx(Form, { children: _jsxs(Box, Object.assign({ sx: { maxWidth: 700 } }, { children: [_jsxs(SectionPaper, Object.assign({ elevation: 3 }, { children: [_jsx(SectionTitle, Object.assign({ variant: "h5" }, { children: "\u0422\u0438\u043F \u043E\u043F\u043B\u0430\u0442\u044B" })), _jsx(FormControl, Object.assign({ fullWidth: true }, { children: _jsxs(RadioGroup, Object.assign({ "aria-labelledby": "payment-type-radio-group", name: "payment-type-radio-group", defaultValue: "0", onChange: (e) => setFieldValue("isAdditional", e.target.value === "1"), sx: { paddingLeft: 2 } }, { children: [_jsx(FormControlLabel, { value: "0", control: _jsx(Radio, {}), label: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u0433\u0440\u0430 \u0432\u0435\u0447\u0435\u0440\u0430", disabled: isSubmitting, sx: { marginBottom: 1, color: '#000000', '&.Mui-disabled': { color: 'rgba(0, 0, 0, 0.6)' } } }), _jsx(FormControlLabel, { value: "1", control: _jsx(Radio, {}), label: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u0430", disabled: isSubmitting, sx: { color: '#000000', '&.Mui-disabled': { color: 'rgba(0, 0, 0, 0.6)' } } })] })) }))] })), _jsx(Box, Object.assign({ sx: { display: "flex", justifyContent: "center", marginTop: 4 } }, { children: _jsx(Button, Object.assign({ variant: "contained", size: "large", type: "submit", disabled: isSubmitting, sx: {
                                            minWidth: 250,
                                            height: 56,
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            borderRadius: 2
                                        } }, { children: isSubmitting ? "Создание игры..." : "Создать игру" })) }))] })) })) }))] }) }));
};
